import type { Room } from '@hollowveil/shared';

export const roomJurassicPark: Room = {
  id: 'room_jurassic_park',
  name: "Jurassic Park - Isla Nublar",
  description: "Bienvenue à Jurassic Park ! Un parc d'attractions préhistorique où les dinosaures ont été ramenés à la vie...",
  size: [24, 10, 24],
  floorStyle: 'grass',
  ambiance: {
    realWorld: {
      backgroundColor: '#87CEEB',
      ambientLightColor: '#FFFACD',
      ambientLightIntensity: 0.9,
    },
    spectralWorld: {
      // Nuit de tempête - dinosaures en liberté
      backgroundColor: '#1a1a2a',
      ambientLightColor: '#4a5a6a',
      ambientLightIntensity: 0.2,
      fogColor: '#2a3a4a',
      fogDensity: 0.06,
    },
  },
  objects: [
    // === ENTREE DU PARC ===
    {
      id: 'obj_jp_gate',
      name: 'Portail Jurassic Park',
      type: 'interactive',
      modelId: 'jp_gate',
      position: [12, 0, 2],
      rotation: [0, 0, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Bienvenue... à Jurassic Park !",
          },
        },
      ],
    },

    // === JEEPS DE TOUR ===
    {
      id: 'obj_jeep_1',
      name: 'Jeep Tour #04',
      type: 'interactive',
      modelId: 'jp_jeep',
      position: [8, 0, 6],
      rotation: [0, 0.3, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Une Jeep Wrangler du tour. Les systèmes de navigation sont hors ligne...",
          },
        },
      ],
    },
    {
      id: 'obj_jeep_2',
      name: 'Jeep Tour #05',
      type: 'static',
      modelId: 'jp_jeep',
      position: [16, 0, 8],
      rotation: [0, -0.5, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },

    // === CLOTURES ELECTRIQUES ===
    {
      id: 'obj_fence_1',
      name: 'Clôture Électrique',
      type: 'static',
      modelId: 'electric_fence',
      position: [4, 0, 12],
      rotation: [0, Math.PI / 2, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { length: 8 },
    },
    {
      id: 'obj_fence_2',
      name: 'Clôture Électrique',
      type: 'static',
      modelId: 'electric_fence',
      position: [20, 0, 12],
      rotation: [0, Math.PI / 2, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { length: 8 },
    },
    // Clôture cassée dans le monde spectral
    {
      id: 'obj_fence_broken',
      name: 'Clôture Détruite',
      type: 'interactive',
      modelId: 'debris',
      position: [4, 0, 12],
      rotation: [0.3, 0.5, 0.2],
      scale: [2, 1, 2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "La clôture a été arrachée... quelque chose de gros est passé par là.",
          },
        },
      ],
    },

    // === CENTRE DES VISITEURS ===
    {
      id: 'obj_visitor_center',
      name: 'Centre des Visiteurs',
      type: 'interactive',
      modelId: 'visitor_center',
      position: [12, 0, 20],
      rotation: [0, Math.PI, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Le Centre des Visiteurs de Jurassic Park. La bannière 'When Dinosaurs Ruled The Earth' gît au sol...",
          },
        },
      ],
    },

    // === NIDS DE DINOSAURES ===
    {
      id: 'obj_nest_1',
      name: 'Nid de Vélociraptor',
      type: 'interactive',
      modelId: 'dino_nest',
      position: [6, 0, 16],
      rotation: [0, 0.5, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "Un nid de raptor avec des œufs. La vie trouve toujours un chemin...",
          },
        },
      ],
    },
    {
      id: 'obj_nest_2',
      name: 'Nid Abandonné',
      type: 'static',
      modelId: 'dino_nest',
      position: [18, 0, 14],
      rotation: [0, 1.2, 0],
      scale: [1.2, 1.2, 1.2],
      visibleInWorld: 'spectral',
      interactableInWorld: 'spectral',
      properties: {},
    },

    // === VEGETATION TROPICALE ===
    {
      id: 'obj_palm_1',
      name: 'Palmier',
      type: 'static',
      modelId: 'palm_tree',
      position: [4, 0, 4],
      rotation: [0, 0.3, 0],
      scale: [1.5, 1.8, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    {
      id: 'obj_palm_2',
      name: 'Palmier',
      type: 'static',
      modelId: 'palm_tree',
      position: [20, 0, 4],
      rotation: [0, 1.5, 0],
      scale: [1.3, 1.6, 1.3],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    {
      id: 'obj_fern_1',
      name: 'Fougère Géante',
      type: 'static',
      modelId: 'giant_fern',
      position: [3, 0, 10],
      rotation: [0, 0.8, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },
    {
      id: 'obj_fern_2',
      name: 'Fougère Géante',
      type: 'static',
      modelId: 'giant_fern',
      position: [21, 0, 16],
      rotation: [0, 2.1, 0],
      scale: [1.3, 1.3, 1.3],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
    },

    // === ROUTE DU TOUR ===
    {
      id: 'obj_road',
      name: 'Route du Tour',
      type: 'static',
      modelId: 'road_segment',
      position: [12, 0, 10],
      rotation: [0, 0, 0],
      scale: [1, 1, 1],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: { length: 20, width: 3 },
    },

    // === OBJETS SPECIAUX ===
    {
      id: 'obj_amber',
      name: 'Ambre avec Moustique',
      type: 'interactive',
      modelId: 'crystal',
      position: [10, 0.5, 18],
      rotation: [0, 0, 0],
      scale: [0.8, 0.8, 0.8],
      visibleInWorld: 'real',
      interactableInWorld: 'real',
      properties: { color: '#ffaa00' },
      onInteract: [
        {
          type: 'addToInventory',
          params: {
            itemId: 'amber',
            itemName: 'Ambre Préhistorique',
            itemDescription: "Un morceau d'ambre contenant un moustique fossilisé. L'ADN de dinosaure qu'il contient a tout commencé...",
            itemIcon: 'crystal',
          },
        },
        {
          type: 'showMessage',
          params: {
            message: "Vous avez trouvé l'ambre légendaire contenant l'ADN de dinosaure !",
          },
        },
        {
          type: 'hideObject',
          params: { objectId: 'obj_amber' },
        },
      ],
    },

    // === PANNEAU D'AVERTISSEMENT ===
    {
      id: 'obj_warning_sign',
      name: 'Panneau Danger',
      type: 'interactive',
      modelId: 'signpost',
      position: [6, 0, 8],
      rotation: [0, 0.3, 0],
      scale: [1.5, 1.5, 1.5],
      visibleInWorld: 'both',
      interactableInWorld: 'both',
      properties: {},
      onInteract: [
        {
          type: 'showMessage',
          params: {
            message: "DANGER: Zone des Raptors - Personnel Autorisé Uniquement",
          },
        },
      ],
    },
  ],
  puzzles: [],
  connections: [],
  initialWorld: 'real',
  hasSpectralLayer: true,
  palette: 'forest',
  biome: 'jungle',
  weather: 'drizzle',
  weatherIntensity: 0.4,
  npcs: [
    // === MONDE REEL - DINOSAURES DOCILES ===
    {
      id: 'npc_brachio',
      type: 'brachiosaurus',
      name: 'Brachiosaurus',
      position: [18, 0, 18],
      scale: 4,
      idleAnimation: 'graze',
      petAnimation: 'happy',
      petRadius: 4,
      petCooldown: 3000,
      isPettable: true,
      visibleInWorld: 'real',
    },
    {
      id: 'npc_trike',
      type: 'triceratops',
      name: 'Triceratops',
      position: [6, 0, 18],
      scale: 3.5,
      idleAnimation: 'graze',
      petAnimation: 'nuzzle',
      petRadius: 3,
      petCooldown: 2500,
      isPettable: true,
      visibleInWorld: 'real',
    },

    // === MONDE SPECTRAL - DINOSAURES DANGEREUX ===
    {
      id: 'npc_trex',
      type: 't_rex',
      name: 'Tyrannosaurus Rex',
      position: [12, 0, 12],
      rotation: [0, Math.PI, 0],
      scale: 5,
      idleAnimation: 'idle',
      petAnimation: 'roar',
      petRadius: 6,
      petCooldown: 10000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_raptor_1',
      type: 'velociraptor',
      name: 'Velociraptor Alpha',
      position: [8, 0, 14],
      scale: 3,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 3,
      petCooldown: 5000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_raptor_2',
      type: 'velociraptor',
      name: 'Velociraptor',
      position: [16, 0, 16],
      scale: 2.8,
      idleAnimation: 'prowl',
      petAnimation: 'growl',
      petRadius: 3,
      petCooldown: 5000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
    {
      id: 'npc_pterodactyl',
      type: 'pterodactyl',
      name: 'Pteranodon',
      position: [10, 3, 8],
      scale: 4,
      idleAnimation: 'fly',
      petAnimation: 'chirp',
      petRadius: 3,
      petCooldown: 4000,
      isPettable: false,
      visibleInWorld: 'spectral',
    },
  ],
};
